import { Banner } from "@neru/ui";

interface ProductBannerProps {
  className?: string;
  isLive?: boolean;
  isProductOwner?: boolean;
  isPublic?: boolean;
  isUnlisted?: boolean;
}

export const ProductBanner = ({
  className,
  isLive,
  isProductOwner,
  isPublic,
  isUnlisted,
}: ProductBannerProps) => {
  if (isLive && isUnlisted) {
    return (
      <Banner
        className={className}
        message="This product is accessible with a direct link only."
        open
      />
    );
  }

  if (!isProductOwner) return;

  if (!(isLive && isPublic)) {
    return (
      <Banner
        className={className}
        message="This product is only visible to you."
        open
      />
    );
  }
};
